export default "__VITE_ASSET__DLkvITVP__"